import axios from "axios";
import { auth } from "../firebase";
import { getSharedDeviceUid } from "../common/util";

const bkstApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

bkstApi.interceptors.request.use(async (config) => {
  return new Promise(async (resolve, reject) => {
    auth.onAuthStateChanged(async function (user) {
      let idToken = "";
      if (user) {
        idToken = await user.getIdToken();
      }
      config.headers.Authorization = `Bearer ${idToken}`;
      config.headers[`bkst-version`] = process.env.REACT_APP_VERSION;
      const dcid = getSharedDeviceUid();
      if (dcid) {
        config.headers["bkst-dcid"] = dcid;
      } else {
        delete config.headers["bkst-dcid"];
      }
      resolve(config);
    });
  });
});

bkstApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    // Let the access-code screen handle bad PINs; don't bounce to /login.
    const isLoginWithCode = url.includes("/login-with-code");

    if ((status === 401 || status === 403) && !isLoginWithCode) {
      window.location.href = `/login?target=${window.location.pathname}`;
    } else if (status === 301 || status === 302) {
      window.location.replace(error.response.data.location);
    }

    return Promise.reject(error);
  }
);

export default bkstApi;
